export function getToken(): string | null {
  return localStorage.getItem("token") || localStorage.getItem("access_token");
}
